import React, { ReactElement, useEffect, useState } from "react";
import {
    FormFieldReplacementInput,
    FormFieldType, FormType,
    WorkflowStepParameterInput, useGetActionFieldsQuery,
} from "../../../__generated__/api";
import FieldTypeValueDisplay from "../../form-field/FieldTypeValueDisplay";
import { LoadingIcon } from "../../loading/Loading";
import RequestTypes from "../../pickers/request-types/RequestTypes";
import { ActionProps } from "./base";

const ACTION_FIELD = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,action)";
const PARAMETERS_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,parameters)";

export default function RunActionSettings(props: ActionProps): ReactElement {
    const actionType = props.values.find(row => row.value.fieldId === ACTION_FIELD);
    const valuesType = props.values.find(row => row.value.fieldId === PARAMETERS_FIELD_ID);

    const [parameters, setParameters] = useState<WorkflowStepParameterInput[]>(JSON.parse(valuesType?.value?.string ?? "[]"));

    const [selectedActionType, setSelectedActionType] = useState<{id: string, name: string} | undefined>(actionType ? {
        id: actionType?.value.string as string,
        name: actionType?.value.displayValue as string,
    } : undefined);

    const { data, loading } = useGetActionFieldsQuery({
        skip: selectedActionType == null,
        variables: {
            id: selectedActionType?.id,
        },
    });

    useEffect(() => {
        if (selectedActionType) {
            props.onChange({
                values: [
                    {
                        fieldId: ACTION_FIELD,
                        type: FormFieldType.AsyncDropdown,
                        displayValue: selectedActionType?.name,
                        string: selectedActionType?.id,
                    },
                    {
                        fieldId: PARAMETERS_FIELD_ID,
                        type: FormFieldType.LongText,
                        displayValue: parameters.firstElement?.value?.string ?? "",
                        string: JSON.stringify(parameters),
                    },
                ],
            });
        }
    }, [selectedActionType?.id, parameters]);

    const fieldMap = data?.formFields.toIdMap("id") ?? {};
    return (
        <div className="">
            <div className="mb-4">
                <div className="">
                    Action
                </div>
                <div className="">
                    <RequestTypes
                        type={FormType.Action}
                        onSelected={(value, text) => {
                            setSelectedActionType({ id: value, name: text });
                            setParameters([]);
                        }}
                        value={selectedActionType?.id}
                    />
                </div>
                <small>
                    Which action do you want to run?
                </small>
            </div>
            {loading && <LoadingIcon />}

            {data?.form?.fields?.map(descriptor => {
                const field = fieldMap[descriptor.fieldId];
                const value = parameters.find(row => row.value.fieldId === field.id);
                return (

                    <FieldTypeValueDisplay
                        key={field.id}
                        shouldShowFieldName
                        className="mb-3"
                        inputClassName="form-control"
                        field={field}
                        replaceableInput={props.input}
                        replacements={value?.replacement as FormFieldReplacementInput[]}
                        value={value?.value}
                        onChange={(changedValue, replacements) => {
                            const copy = Array.from(parameters);
                            const index = parameters.findIndex(row => row.value.fieldId === field.id);
                            if (index >= 0) {
                                copy[index] = {
                                    value: changedValue,
                                    replacement: replacements,
                                };
                            } else {
                                copy.push({
                                    value: changedValue,
                                    replacement: replacements,
                                });
                            }
                            setParameters(copy);
                        }}
                    />

                );
            })}

        </div>

    );
}
